var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41266 4.4164L3.98946 2.994L5.41186 1.5716C5.68546 1.2988 5.68546 0.8548 5.41186 0.582C5.13826 0.3068 4.69586 0.3076 4.42226 0.5812L2.99906 2.0036L1.57586 0.5796C1.30226 0.306 0.859059 0.3076 0.585459 0.5796C0.312659 0.8532 0.312659 1.2972 0.585459 1.57L2.00946 2.994L0.588659 4.414C0.315059 4.6876 0.315059 5.1316 0.588659 5.4036C0.725459 5.5412 0.903859 5.6092 1.08306 5.6092C1.26306 5.6092 1.44146 5.5412 1.57826 5.4044L2.99906 3.9836L4.42306 5.4068C4.55986 5.5436 4.73826 5.6116 4.91746 5.6116C5.09666 5.6116 5.27586 5.5428 5.41266 5.4068C5.68626 5.1332 5.68626 4.69 5.41266 4.4164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.20192bbb38bcb71d273e48ae4ec384f4.svg";
export { ForwardRef as ReactComponent };